exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "td[data-v-52b73a21]{border-bottom-width:1px;--tw-border-opacity:1;border-color:rgba(229,231,235,var(--tw-border-opacity));--tw-bg-opacity:1;background-color:rgba(255,255,255,var(--tw-bg-opacity));padding:1.25rem;font-size:.875rem;line-height:1.25rem}p[data-v-52b73a21]{--tw-text-opacity:1;color:rgba(80,95,115,var(--tw-text-opacity))}", ""]);

// exports
